import { Button, Dropdown, Row, Space } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import ImportProjectModal from '../../modules/goodsImportModules/ImportProject'
import { DownOutlined } from '@ant-design/icons'
import { history } from '../../redux/store'
import { formatterPrice } from '@/tools/util'

const operationMenuList = [
  '导入上架项目',
  '导入图片',
  '导入拓展属性',
  '导入资质图片',
]

export default function ToSubmitGoods() {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleTableRefresh,
    handleOperationMenuClick,
    cancelImportModal,
    handleDelClick,
    handleAuditSubmit,
    handleImportSuccess,
    onJump,
  } = useSetupHook()
  const {
    dataSource,
    isTableLoading,
    paginationOption,
    selectedRowKeys,
    importModalOption,
    selectedRows,
  } = state

  const items = operationMenuList.map((item) => ({
    label: item,
    key: item,
  }))
  const columns = [
    {
      key: 'productType',
      dataIndex: 'productType',
      title: '物料类型',
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'referenceSupplyPrice',
      dataIndex: 'referenceSupplyPrice',
      title: '参考供货价',
      render: (text: string) => (text ? formatterPrice(text) : '-'),
    },
    {
      key: 'relevancyPlatform',
      dataIndex: 'relevancyPlatform',
      title: '关联项目',
    },
    {
      key: 'mainPicture',
      dataIndex: 'mainPicture',
      title: '主图',
    },
    {
      key: 'detailsPicture',
      dataIndex: 'detailsPicture',
      title: '详情图',
    },
    {
      key: 'extendedAttribute',
      dataIndex: 'extendedAttribute',
      title: '拓展属性',
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'srmProductType',
          'tempCode',
          'name',
          'brand',
          'model',
          'unitCode',
          // 'referenceSupplyPrice',
          // 'platformCodes',
          'srmPlatformCodes',
          'mainPicture',
          'detailsPicture',
          'extendedAttribute',
        ]}
        onSearch={handleSearchClick}
        keyName="ACCOUNT"
        ScreenKey="ACCOUNT"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <span> 待提交物料列表</span>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
        <Space>
          <Button size="middle">
            <span className="btn-danger" onClick={handleDelClick}>
              删除
            </span>
          </Button>

          <Dropdown menu={{ items, onClick: handleOperationMenuClick }}>
            <Button size="middle">
              批量修改 <DownOutlined />
            </Button>
          </Dropdown>
          <Button size="middle" onClick={handleAuditSubmit}>
            提交审核
          </Button>
          <Button
            size="middle"
            type="primary"
            onClick={() => {
              history.push('/srm/newBatchAdd')
            }}
          >
            批量导入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>

      <ImportProjectModal
        {...importModalOption}
        onCancel={cancelImportModal}
        productIds={selectedRowKeys}
        productType={selectedRows?.[0]?.productType}
        onImportSuccess={handleImportSuccess}
      ></ImportProjectModal>
    </div>
  )
}
import { Button, Dropdown, Row, Space } from 'antd'
import Search from '../../components/SearchFilter'
import TableAntd from '../../components/TableAntd'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import ImportProjectModal from '../../modules/goodsImportModules/ImportProject'
import { DownOutlined } from '@ant-design/icons'
import { history } from '../../redux/store'
import { formatterPrice } from '@/tools/util'

const operationMenuList = [
  '导入上架项目',
  '导入图片',
  '导入拓展属性',
  '导入资质图片',
]

export default function ToSubmitGoods() {
  const {
    state,
    handlePaginationChange,
    handleTableChangeCheck,
    handleSearchClick,
    handleTableRefresh,
    handleOperationMenuClick,
    cancelImportModal,
    handleDelClick,
    handleAuditSubmit,
    handleImportSuccess,
    onJump,
  } = useSetupHook()
  const {
    dataSource,
    isTableLoading,
    paginationOption,
    selectedRowKeys,
    importModalOption,
    selectedRows,
  } = state

  const items = operationMenuList.map((item) => ({
    label: item,
    key: item,
  }))
  const columns = [
    {
      key: 'productType',
      dataIndex: 'productType',
      title: '物料类型',
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'referenceSupplyPrice',
      dataIndex: 'referenceSupplyPrice',
      title: '参考供货价',
      render: (text: string) => (text ? formatterPrice(text) : '-'),
    },
    {
      key: 'relevancyPlatform',
      dataIndex: 'relevancyPlatform',
      title: '关联项目',
    },
    {
      key: 'mainPicture',
      dataIndex: 'mainPicture',
      title: '主图',
    },
    {
      key: 'detailsPicture',
      dataIndex: 'detailsPicture',
      title: '详情图',
    },
    {
      key: 'extendedAttribute',
      dataIndex: 'extendedAttribute',
      title: '拓展属性',
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'srmProductType',
          'tempCode',
          'name',
          'brand',
          'model',
          'unitCode',
          // 'referenceSupplyPrice',
          // 'platformCodes',
          'srmPlatformCodes',
          'mainPicture',
          'detailsPicture',
          'extendedAttribute',
        ]}
        onSearch={handleSearchClick}
        keyName="ACCOUNT"
        ScreenKey="ACCOUNT"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <span> 待提交物料列表</span>
          <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        </Space>
        <Space>
          <Button size="middle">
            <span className="btn-danger" onClick={handleDelClick}>
              删除
            </span>
          </Button>

          <Dropdown menu={{ items, onClick: handleOperationMenuClick }}>
            <Button size="middle">
              批量修改 <DownOutlined />
            </Button>
          </Dropdown>
          <Button size="middle" onClick={handleAuditSubmit}>
            提交审核
          </Button>
          <Button
            size="middle"
            type="primary"
            onClick={() => {
              history.push('/srm/newBatchAdd')
            }}
          >
            批量导入
          </Button>
        </Space>
      </Row>
      <TableAntd
        dataSource={dataSource}
        listColumn={columns}
        loading={isTableLoading}
        Y={340}
        pagination={{
          ...paginationOption,
          onChange: handlePaginationChange,
        }}
        showSize
        onChangeCheck={handleTableChangeCheck}
      ></TableAntd>

      <ImportProjectModal
        {...importModalOption}
        onCancel={cancelImportModal}
        productIds={selectedRowKeys}
        productType={selectedRows?.[0]?.productType}
        onImportSuccess={handleImportSuccess}
      ></ImportProjectModal>
    </div>
  )
}
